import { render, staticRenderFns } from "./ExpandableHtml.vue?vue&type=template&id=0da35e6c&"
import script from "./ExpandableHtml.vue?vue&type=script&lang=js&"
export * from "./ExpandableHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports